export const ROLES = [
  { value: "INSPECTEUR", label: "Inspecteur" },
  { value: "RESPONSABLE", label: "Responsable" },
  { value: "ADMINISTRATEUR", label: "Administrateur" },
  { value: "CONDUCTEUR_ENGINS", label: "Conducteur d'engins" },
  { value: "CHEF_EQUIPE", label: "Chef d'équipe" },
  { value: "CONTREMAITRE", label: "Contremaître" },
  { value: "BOUTEFEU", label: "Boutefeu" },
];

export const roleLabel = (v, catalog) => {
  const list = catalog && catalog.length ? catalog : ROLES;
  return list.find((r) => r.value === v)?.label || v;
};

export const hasRole = (user, ...roles) =>
  !!user && Array.isArray(user.Roles) && user.Roles.some((r) => roles.includes(r));
